/* Bien Etre theme — no dependencies */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, root) { return (root || document).querySelector(s); }
  function $$(s, root) { return Array.prototype.slice.call((root || document).querySelectorAll(s)); }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key));
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }
  function formatMoney(cents) {
    var iso = (window.BE && window.BE.currency) || '';
    var parts = (cents / 100).toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (iso ? iso + ' ' : '') + whole + (parts[1] === '00' ? '' : '.' + parts[1]);
  }

  /* ---------- header ---------- */
  function initHeader() {
    var header = $('.site-header');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    $$('[data-mega-trigger]').forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var closeTimer;
      function open() { clearTimeout(closeTimer); btn.setAttribute('aria-expanded', 'true'); panel.classList.add('is-open'); }
      function close() { btn.setAttribute('aria-expanded', 'false'); panel.classList.remove('is-open'); }
      btn.addEventListener('click', function () { btn.getAttribute('aria-expanded') === 'true' ? close() : open(); });
      [btn, panel].forEach(function (el) {
        el.addEventListener('mouseenter', open);
        el.addEventListener('mouseleave', function () { closeTimer = setTimeout(close, 180); });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); } });
      panel.addEventListener('focusout', function (e) { if (!panel.contains(e.relatedTarget) && e.relatedTarget !== btn) close(); });
    });

    var mobile = $('.mobile-nav');
    $$('[data-menu-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        mobile.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        var first = $('[data-menu-close]', mobile);
        if (first) first.focus();
      });
    });
    $$('[data-menu-close]').forEach(function (b) {
      b.addEventListener('click', function () { mobile.classList.remove('is-open'); document.body.style.overflow = ''; });
    });
  }

  /* ---------- reveal + line drawing ---------- */
  function prepDraw(svg) {
    $$('path, circle, line, ellipse, rect, polyline', svg).forEach(function (el) {
      if (el.getAttribute('data-nodraw') !== null || !el.getTotalLength) return;
      try { var len = Math.ceil(el.getTotalLength()); el.style.setProperty('--len', len); } catch (e) {}
    });
  }
  function initReveal() {
    $$('.draw').forEach(prepDraw);
    var targets = $$('[data-reveal], .draw, .chain, [data-count]');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      $$('[data-count]').forEach(function (el) { el.textContent = el.getAttribute('data-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('is-in');
        if (el.hasAttribute('data-count')) countUp(el);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
    targets.forEach(function (el) { io.observe(el); });
  }
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var decimals = (el.getAttribute('data-count').split('.')[1] || '').length;
    var start = performance.now(), dur = 1600;
    function tick(now) {
      var p = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = (target * eased).toFixed(decimals);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ---------- hero dial ---------- */
  function initDial() {
    $$('[data-dial]').forEach(function (dial) {
      var label = $('[data-dial-marker]', dial);
      var unit = $('[data-dial-unit]', dial);
      var cat = $('[data-dial-cat]', dial);
      var items;
      try { items = JSON.parse(dial.getAttribute('data-dial')); } catch (e) { return; }
      if (!items || !items.length || reduceMotion) return;
      var i = 0;
      setInterval(function () {
        if (document.hidden) return;
        i = (i + 1) % items.length;
        label.classList.add('is-out');
        setTimeout(function () {
          label.textContent = items[i][0];
          if (cat) cat.textContent = items[i][1];
          if (unit) unit.textContent = items[i][2];
          label.classList.remove('is-out');
        }, 380);
      }, 2600);
    });
  }

  /* ---------- sticky steps ---------- */
  function initSteps() {
    $$('[data-steps]').forEach(function (wrap) {
      var steps = $$('.step', wrap);
      var arts = $$('[data-step-art]', wrap);
      if (!steps.length) return;
      function activate(idx) {
        steps.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        arts.forEach(function (a, i) { a.classList.toggle('is-active', i === idx); });
      }
      activate(0);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) activate(steps.indexOf(e.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    });
  }

  /* ---------- biomarker filter ---------- */
  function initMarkers() {
    $$('[data-markers]').forEach(function (wrap) {
      var chips = $$('.chip', wrap);
      var cells = $$('.marker', wrap);
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var f = chip.getAttribute('data-filter');
          chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          cells.forEach(function (m) { m.classList.toggle('is-dim', f !== 'all' && m.getAttribute('data-cat') !== f); });
        });
      });
    });
  }

  /* ---------- quiz ---------- */
  function initQuiz() {
    $$('[data-quiz]').forEach(function (root) {
      var steps = $$('.quiz__step', root);
      var result = $('.quiz__result', root);
      var bars = $$('.quiz__progress span', root);
      var back = $('[data-quiz-back]', root);
      var next = $('[data-quiz-next]', root);
      var counter = $('[data-quiz-counter]', root);
      var recs = {};
      try { recs = JSON.parse($('[data-quiz-recs]', root.parentNode).textContent); } catch (e) {}
      var idx = 0;

      function current() { return steps[idx]; }
      function answered(step) { return !!$('input:checked', step); }
      function sync() {
        steps.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        bars.forEach(function (b, i) { b.classList.toggle('is-done', i < idx || (i === idx && answered(current()))); });
        back.hidden = idx === 0;
        next.disabled = !answered(current());
        next.querySelector('span').textContent = idx === steps.length - 1 ? next.getAttribute('data-finish') : next.getAttribute('data-continue');
        if (counter) counter.textContent = (idx + 1) + ' / ' + steps.length;
      }
      root.addEventListener('change', function (e) {
        if (e.target.type === 'radio' || e.target.type === 'checkbox') {
          if (e.target.type === 'checkbox') {
            var step = e.target.closest('.quiz__step');
            var noneBox = $('input[value="none"]', step);
            if (e.target.value === 'none' && e.target.checked) {
              $$('input[type="checkbox"]', step).forEach(function (c) { if (c !== e.target) c.checked = false; });
            } else if (noneBox && e.target.checked) { noneBox.checked = false; }
          }
          sync();
        }
      });
      root.addEventListener('keydown', function (e) {
        if (!current() || !current().classList.contains('is-active')) return;
        var n = parseInt(e.key, 10);
        if (n >= 1 && n <= 9 && !/INPUT|TEXTAREA/.test((document.activeElement || {}).tagName || '')) {
          var inputs = $$('input', current());
          if (inputs[n - 1]) { inputs[n - 1].click(); }
        }
        if (e.key === 'Enter' && !next.disabled && document.activeElement && document.activeElement.type !== 'submit') {
          if (root.contains(document.activeElement) && document.activeElement.tagName === 'INPUT') { e.preventDefault(); next.click(); }
        }
      });
      back.addEventListener('click', function () { if (idx > 0) { idx--; sync(); } });
      next.addEventListener('click', function () {
        if (!answered(current())) return;
        if (idx < steps.length - 1) { idx++; sync(); focusStep(); }
        else finish();
      });
      function focusStep() {
        var q = $('.quiz__q', current());
        if (q) { q.setAttribute('tabindex', '-1'); q.focus({ preventScroll: true }); }
      }

      function finish() {
        var score = { nad: 0, skin: 0, nutri: 0 };
        $$('input:checked', root).forEach(function (inp) {
          ['nad', 'skin', 'nutri'].forEach(function (k) {
            var v = parseFloat(inp.getAttribute('data-' + k) || 0);
            score[k] += v;
          });
        });
        var measured = $$('[data-measured] input:checked', root).map(function (i) { return i.value; });
        var domains = [
          { key: 'nad', label: root.getAttribute('data-l-nad') },
          { key: 'vitamins', label: root.getAttribute('data-l-vitamins') },
          { key: 'omega', label: root.getAttribute('data-l-omega') },
          { key: 'hormones', label: root.getAttribute('data-l-hormones') },
          { key: 'amino', label: root.getAttribute('data-l-amino') },
          { key: 'skin', label: root.getAttribute('data-l-skin') }
        ];
        var list = $('.coverage', result);
        list.innerHTML = '';
        var count = 0;
        domains.forEach(function (d) {
          var m = measured.indexOf(d.key) > -1;
          if (m) count++;
          var li = document.createElement('li');
          li.innerHTML = '<span></span><span class="tag ' + (m ? 'tag--measured' : 'tag--guess') + '"></span>';
          li.firstChild.textContent = d.label;
          li.lastChild.textContent = m ? root.getAttribute('data-l-measured') : root.getAttribute('data-l-guessing');
          list.appendChild(li);
        });
        // unmeasured areas push their unit up
        if (measured.indexOf('nad') < 0) score.nad += 1;
        if (measured.indexOf('skin') < 0) score.skin += 0.5;
        ['vitamins', 'omega', 'hormones', 'amino'].forEach(function (k) { if (measured.indexOf(k) < 0) score.nutri += 0.4; });

        var top = Object.keys(score).sort(function (a, b) { return score[b] - score[a]; })[0];
        var rec = recs[top] || {};
        $('[data-measured-count]', result).textContent = count;
        $('[data-rec-label]', result).textContent = rec.label || '';
        $('[data-rec-title]', result).textContent = rec.title || '';
        $('[data-rec-body]', result).textContent = rec.body || '';
        var cta = $('[data-rec-cta]', result);
        cta.setAttribute('href', rec.url || '#');
        $('span', cta).textContent = rec.cta || '';

        steps.forEach(function (s) { s.classList.remove('is-active'); });
        bars.forEach(function (b) { b.classList.add('is-done'); });
        $('.quiz__nav', root).style.display = 'none';
        if (counter) counter.textContent = root.getAttribute('data-l-complete');
        result.classList.add('is-active');
        var h = $('.quiz__q', result); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
        store('be-quiz', { top: top, measured: measured, at: Date.now() });
      }
      var restart = $('[data-quiz-restart]', root);
      if (restart) restart.addEventListener('click', function () {
        $$('input', root).forEach(function (i) { i.checked = false; });
        idx = 0; result.classList.remove('is-active');
        $('.quiz__nav', root).style.display = '';
        sync(); focusStep();
      });
      sync();
    });
  }

  /* ---------- cart ---------- */
  var drawer, overlay;
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open'); overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    var c = $('[data-drawer-close]', drawer); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }
  function renderCart(cart) {
    $$('.cart-count').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
    if (!drawer) return;
    var body = $('.drawer__body', drawer);
    var foot = $('.drawer__foot', drawer);
    body.innerHTML = '';
    if (!cart.items.length) {
      var p = document.createElement('p'); p.className = 'drawer__empty'; p.textContent = drawer.getAttribute('data-empty');
      body.appendChild(p); foot.hidden = true; return;
    }
    foot.hidden = false;
    cart.items.forEach(function (item, i) {
      var row = document.createElement('div');
      row.className = 'line';
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="72" height="72" loading="lazy">' : '<span></span>';
      row.innerHTML = img +
        '<div><a class="line__title" href="' + item.url + '"></a><div class="line__meta"></div>' +
        '<div class="qty"><button type="button" data-qty="' + (item.quantity - 1) + '" data-line="' + (i + 1) + '" aria-label="Decrease">−</button><span>' + item.quantity + '</span><button type="button" data-qty="' + (item.quantity + 1) + '" data-line="' + (i + 1) + '" aria-label="Increase">+</button></div></div>' +
        '<div class="line__price">' + formatMoney(item.final_line_price) + '</div>';
      $('.line__title', row).textContent = item.product_title;
      $('.line__meta', row).textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      body.appendChild(row);
    });
    $('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price);
  }
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function initCart() {
    drawer = $('.drawer'); overlay = $('.drawer-overlay');
    $$('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { if (!drawer) return; e.preventDefault(); fetchCart().then(renderCart).then(openDrawer); });
    });
    $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    if (drawer) drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      fetch(window.BE.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(b.getAttribute('data-line'), 10), quantity: Math.max(0, parseInt(b.getAttribute('data-qty'), 10)) })
      }).then(function (r) { return r.json(); }).then(renderCart);
    });

    $$('form[data-ajax-cart]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!drawer || !window.fetch) return;
        e.preventDefault();
        var btn = $('[type="submit"]', form);
        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        fetch(window.BE.routes.cartAdd + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(fetchCart).then(renderCart).then(openDrawer)
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; } });
      });
    });
  }

  /* ---------- product ---------- */
  function initProduct() {
    $$('[data-product]').forEach(function (root) {
      var variants;
      try { variants = JSON.parse($('[data-variants]', root).textContent); } catch (e) { return; }
      var idInput = $('input[name="id"]', root);
      var price = $('[data-price]', root);
      var compare = $('[data-compare]', root);
      var addBtn = $('[data-add]', root);
      root.addEventListener('change', function (e) {
        if (!e.target.closest('.variant-picker')) return;
        var chosen = $$('.variant-picker', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!match) return;
        idInput.value = match.id;
        price.textContent = formatMoney(match.price);
        if (compare) compare.textContent = match.compare_at_price > match.price ? formatMoney(match.compare_at_price) : '';
        var offer = match.compare_at_price > match.price;
        var badge = $('[data-offer]', root), save = $('[data-save]', root);
        if (badge) badge.hidden = !offer;
        if (save) { save.hidden = !offer; save.textContent = offer ? save.getAttribute('data-template').replace('__AMT__', formatMoney(match.compare_at_price - match.price)) : ''; }
        addBtn.disabled = !match.available;
        $('span', addBtn).textContent = match.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-sold');
        var url = new URL(window.location.href); url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      });
      $$('[data-thumb]', root).forEach(function (t) {
        t.addEventListener('click', function () {
          var main = $('[data-main-image]', root);
          main.src = t.getAttribute('data-src'); main.srcset = '';
          $$('[data-thumb]', root).forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
        });
      });
    });
  }

  /* ---------- video: poster first, load after page load and only when visible ---------- */
  function initVideo() {
    var vids = $$('video[data-lazy-video]');
    if (!vids.length || reduceMotion) return;
    var saveData = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));
    if (saveData) return;
    function pick(v) {
      var w = v.getBoundingClientRect().width * (window.devicePixelRatio || 1);
      var key = w < 520 ? 'data-src-480' : (w < 900 ? 'data-src-720' : 'data-src-1080');
      return v.getAttribute(key) || v.getAttribute('data-src-1080');
    }
    function start(v) {
      if (!v.getAttribute('src')) {
        var src = pick(v); if (!src) return;
        v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
        v.src = src;
      }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    function arm() {
      if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) start(e.target); else if (e.target.getAttribute('src')) e.target.pause(); });
      }, { rootMargin: '200px 0px' });
      vids.forEach(function (v) { io.observe(v); });
    }
    if (document.readyState === 'complete') setTimeout(arm, 600);
    else window.addEventListener('load', function () { setTimeout(arm, 600); });
  }

  function initLocale() {
    $$('[data-locale-select]').forEach(function (sel) { sel.addEventListener('change', function () { sel.form.submit(); }); });
  }

  function init() { initLocale(); initVideo(); initHeader(); initReveal(); initDial(); initSteps(); initMarkers(); initQuiz(); initCart(); initProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
